import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";

import { of } from "@nozbe/watermelondb/utils/rx";
import ReceiptTemplate from "../../../../../../utilities/data/model/ReceiptTemplate";
import { TextButton, TextButtonProps } from "@towersystems/roam-common-native";

const getObservables = ({
  receiptTemplate,
}: {
  receiptTemplate: ReceiptTemplate;
}) => ({
  receiptTemplate: receiptTemplate.id ? receiptTemplate.observe() : of(null),
});

export interface ReceiptTemplateTextButtonRendererProps
  extends ExtractedObservables<ReturnType<typeof getObservables>> {
  onPress?: TextButtonProps["onPress"];
}

export const ReceiptTemplateTextButtonRenderer = ({
  receiptTemplate,
  onPress,
}: ReceiptTemplateTextButtonRendererProps) => {
  const text = receiptTemplate ? receiptTemplate.name : "Select Template";
  return <TextButton onPress={onPress}>{text}</TextButton>;
};

const enhance = withObservables(["receiptTemplate"], getObservables);

export const ReceiptTemplateTextButton = enhance(
  ReceiptTemplateTextButtonRenderer
);
